if (process.env.NODE_ENV === 'development') {
  // Must use require here as import statements are only allowed
  // to exist at top-level.
  require('preact/debug');
}

// Use if we want to enable chunks in the future
// eslint-disable-next-line no-undef
// __webpack_public_path__ = window.assetsPath;

import { Snap } from '@searchspring/snap-preact';
import { getContext } from '@searchspring/snap-toolbox';

import { afterStore } from './middleware/plugins/afterStore';
import { configurable } from './middleware/plugins/configurable';
import { Autocomplete } from './components/Autocomplete/Autocomplete';

const context = getContext(['collection', 'tags', 'template', 'shopper', 'region', 'language']);

// Default to bauer.com
let siteId = 'sw514s';

if (context.region == 'ca') {
  if (context.language == 'fr') {
    // Use bauer.com-ca-fr
    siteId = 'dks0lg';
  } else {
    // If not french default to english
    siteId = 'kb2km4';
  }
}

if (context.region == 'se') {
  siteId = '7mwt6w';
}

if (context.region == 'fi') {
  siteId = 'w41l77';
}

if (context.region == 'dk') {
  siteId = 's2qfgx';
}

if (context.region == 'no') {
  // Use nordics-bauer en feed
  siteId = 'wl2wcd';
}

const backgroundFilters = [];

if (context.collection?.handle) {
  // set background filters
  if (context.collection.handle != 'all') {
    backgroundFilters.push({
      field: 'collection_handle',
      value: context.collection.handle,
      type: 'value',
      background: true,
    });
  }

  // handle collection tags (filters)
  if (context.tags) {
    var collectionTags = context.tags.replace(/-/g, '').replace(/ +/g, '').split('|');
    collectionTags.forEach(tag => {
      backgroundFilters.push({
        field: 'tags',
        value: tag,
        type: 'value',
        background: true,
      });
    });
  }
}

/*
	configuration and instantiation
 */

let config = {
  url: {
    settings: {
      coreType: 'query',
      customType: 'query',
    },
    parameters: {
      core: {
        query: { name: 'q' },
        page: { name: 'p' },
      },
    },
  },
  client: {
    globals: {
      siteId: siteId,
    },
  },
  instantiators: {
    recommendation: {
      components: {
        Recommendations: async () => {
          return (await import('./components/Recommendations')).Recs;
        },
      },
      config: {
        branch: 'develop',
      },
    },
  },
  controllers: {
    search: [
      {
        config: {
          id: 'search',
          plugins: [[afterStore], [configurable]],
          settings: {
            redirects: {
              merchandising: true,
            },
            infinite: {},
            facets: {
              pinFiltered: false,
            },
          },
          globals: {
            filters: backgroundFilters,
            pagination: {
              pageSize: window?.ssConfig?.pageSize ?? 24,
            },
            ssConfig: window?.ssConfig,
          },
        },
        targeters: [
          {
            selector: '#searchspring-content',
            hideTarget: true,
            prefetch: true,
            component: async () => {
              return (await import('./components/Content/Content')).Content;
            },
          },
        ],
      },
    ],
    autocomplete: [
      {
        config: {
          id: 'autocomplete',
          selector: '.ss_ac-desktop',
          settings: {
            syncInputs: false,
            trending: {
              limit: 6,
              showResults: true,
            },
          },
        },
        targeters: [
          {
            selector: '.ss_ac-desktop',
            component: async () => Autocomplete,
          },
        ],
      },
      {
        config: {
          id: 'autocomplete-mobile',
          selector: '.ss_ac-mobile',
          settings: {
            syncInputs: false,
            trending: {
              limit: 5,
              showResults: true,
            },
          },
        },
        targeters: [
          {
            selector: '.ss_ac-mobile',
            component: async () => Autocomplete,
          },
        ],
      },
    ],
  },
};

new Snap(config);
